// project-imports
import Avatar from 'components/@extended/Avatar';

// ==============================|| DEVELOPER - ACCOUNT AVATAR ||============================== //

interface Props {
  name: string;
  logo?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

/** The account's logo, or its initials when there is no logo (or the link is broken). */
const AccountAvatar = ({ name, logo, size = 'sm' }: Props) => {
  const initials = name
    .split(' ')
    .filter((part) => part !== '')
    .map((part) => part.charAt(0))
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <Avatar alt={name} src={logo || undefined} size={size} variant="rounded">
      {initials || '?'}
    </Avatar>
  );
};

export default AccountAvatar;
